{
  "name": "@tokens-studio/tokenscript-interpreter",
  "version": "0.37.1",
  "description": "A TypeScript interpreter for TokenScript, a domain-specific language for design token manipulation and computation",
  "type": "module",
  "main": "./dist/lib/index.js",
  "types": "./dist/lib/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/lib/index.d.ts",
        "default": "./dist/lib/index.js"
      },
      "require": {
        "types": "./dist/lib/index.d.cts",
        "default": "./dist/lib/index.cjs"
      }
    },
    "./interpreter": {
      "import": {
        "types": "./dist/lib/interpreter.d.ts",
        "default": "./dist/lib/interpreter.js"
      },
      "require": {
        "types": "./dist/lib/interpreter.d.cts",
        "default": "./dist/lib/interpreter.cjs"
      }
    },
    "./processor": {
      "import": {
        "types": "./dist/lib/processor.d.ts",
        "default": "./dist/lib/processor.js"
      },
      "require": {
        "types": "./dist/lib/processor.d.cts",
        "default": "./dist/lib/processor.cjs"
      }
    },
    "./processor-node": {
      "import": {
        "types": "./dist/lib/processor-node.d.ts",
        "default": "./dist/lib/processor-node.js"
      },
      "require": {
        "types": "./dist/lib/processor-node.d.cts",
        "default": "./dist/lib/processor-node.cjs"
      }
    },
    "./schema": {
      "import": {
        "types": "./dist/lib/schema.d.ts",
        "default": "./dist/lib/schema.js"
      },
      "require": {
        "types": "./dist/lib/schema.d.cts",
        "default": "./dist/lib/schema.cjs"
      }
    },
    "./types": {
      "import": {
        "types": "./dist/lib/types.d.ts",
        "default": "./dist/lib/types.js"
      },
      "require": {
        "types": "./dist/lib/types.d.cts",
        "default": "./dist/lib/types.cjs"
      }
    },
    "./syntax-highlighting": {
      "import": {
        "types": "./dist/lib/syntax-highlighting.d.ts",
        "default": "./dist/lib/syntax-highlighting.js"
      },
      "require": {
        "types": "./dist/lib/syntax-highlighting.d.cts",
        "default": "./dist/lib/syntax-highlighting.cjs"
      }
    },
    "./cli": {
      "types": "./dist/cli.d.ts",
      "import": "./dist/cli.js"
    },
    "./package.json": "./package.json"
  },
  "bin": {
    "tokenscript": "dist/cli.js"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "sideEffects": false,
  "engines": {
    "node": ">=16.0.0"
  },
  "scripts": {
    "build": "npm run build:lib && npm run build:cli",
    "build:lib": "tsup --config tsup.lib.config.ts",
    "build:cli": "tsup --config tsup.cli.config.ts",
    "build:watch": "tsup --watch",
    "clean": "rm -rf dist",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "bench": "vitest bench",
    "bench:processor": "vitest bench tests/performance/processor.bench.ts",
    "check": "biome ci . --diagnostic-level=error",
    "check:all": "npm run check && npm run test",
    "check:errors": "biome ci . --diagnostic-level=error",
    "lint": "biome lint --max-diagnostics=none .",
    "lint:fix": "biome lint --write .",
    "format": "biome format --write .",
    "format:check": "biome format .",
    "format:tests": "biome format --write 'tests/**/*.ts'",
    "fix": "biome check --write .",
    "ts:typecheck": "tsc -p tsconfig.build.json",
    "ts:typecheck:watch": "tsc -p tsconfig.build.json --watch",
    "cli": "tsx src/cli.ts",
    "cli:built": "node dist/cli.js",
    "cli:repl": "tsx src/cli.ts repl",
    "cli:repl:built": "node dist/cli.js repl",
    "compliance": "tsx scripts/compliance-test.ts --test-dir ./data/compliance-suite/tests/ --output compliance-report.json",
    "compliance:failed": "npm run compliance && jq '.results | map(select(.status == \"failed\"))' compliance-report.json",
    "dev:repl": "cd examples/web-repl && npm run dev:watch",
    "dev:graph": "cd examples/graph-visualization && npm run dev",
    "prepublishOnly": "npm run test && npm run build:lib",
    "release": "node scripts/release.js",
    "package:validate": "npx @arethetypeswrong/cli --pack ."
  },
  "keywords": [
    "tokenscript",
    "design-tokens",
    "design-system",
    "interpreter",
    "cli"
  ],
  "author": "Tokens Studio (https://tokens.studio)",
  "license": "MPL-2.0",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/tokens-studio/tokenscript-interpreter.git"
  },
  "bugs": {
    "url": "https://github.com/tokens-studio/tokenscript-interpreter/issues"
  },
  "homepage": "https://github.com/tokens-studio/tokenscript-interpreter#readme",
  "dependencies": {
    "@tokens-studio/schema-validation": "^0.2.0",
    "commander": "^14.0.1",
    "readline-sync": "^1.4.10",
    "yauzl": "^3.2.0"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.2.4",
    "@types/node": "^22.18.6",
    "@types/readline-sync": "^1.4.8",
    "@types/yauzl": "^2.10.3",
    "@vitest/coverage-v8": "^4.0.18",
    "monaco-editor": "^0.53.0",
    "npm-run-all": "^1.1.3",
    "tsup": "^8.5.0",
    "tsx": "^4.20.5",
    "typescript": "^5.9.2",
    "vitest": "^4.0.18"
  }
}
